import {
  DialogTrigger,
  LinkButton,
  Popover,
  PopoverContent,
  SelectFormikField,
  SelectFormikFieldProps,
  SelectItem,
  SelectProps,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface Props {
  name: SelectFormikFieldProps<object>["name"];
  label: SelectProps<object>["label"];
  testID: SelectProps<object>["testID"];
  isRequired?: SelectProps<object>["isRequired"];
  isDisabled?: SelectProps<object>["isDisabled"];
  showInfo?: boolean;
}

export function IndustrySelect(props: Props) {
  const { t } = useTranslation();
  const { name, label, isRequired, testID, isDisabled, showInfo } = props;
  return (
    <SelectFormikField
      name={name}
      label={label}
      isRequired={isRequired}
      testID={testID}
      isDisabled={isDisabled}
      info={
        showInfo ? (
          <DialogTrigger>
            <LinkButton testID="" textStyle="form/body-secondary-link">
              {t("What's this?")}
            </LinkButton>
            <Popover placement="top right">
              <PopoverContent>
                {t(
                  "Industry refers to the sector your business operates in. This helps us tailor the experience and ensure compliance with relevant regulations."
                )}
              </PopoverContent>
            </Popover>
          </DialogTrigger>
        ) : undefined
      }
    >
      <SelectItem id="CONSTRUCTION">{t("Construction")}</SelectItem>
      <SelectItem id="EDUCATION">{t("Education")}</SelectItem>
      <SelectItem id="FINANCIAL_SERVICES">{t("Financial Services")}</SelectItem>
      <SelectItem id="GIG_ECONOMY">{t("Gig Economy")}</SelectItem>
      <SelectItem id="HEALTHCARE_SERVICES">
        {t("Healthcare Services")}
      </SelectItem>
      <SelectItem id="HOSPITALITY_AND_TOURISM">
        {t("Hospitality and Tourism")}
      </SelectItem>
      <SelectItem id="LEGAL">{t("Legal")}</SelectItem>
      <SelectItem id="MANUFACTURING">{t("Manufacturing")}</SelectItem>
      <SelectItem id="NON_PROFIT">{t("Non-Profit")}</SelectItem>
      <SelectItem id="OTHER">{t("Other")}</SelectItem>
      <SelectItem id="PROPERTY_MANAGEMENT">
        {t("Property Management")}
      </SelectItem>
      <SelectItem id="RETAIL_AND_CONSUMER_SERVICES">
        {t("Retail and Consumer Services")}
      </SelectItem>
      <SelectItem id="SOFTWARE_AND_TECHNOLOGY">
        {t("Software and Technology")}
      </SelectItem>
      <SelectItem id="STAFFING">{t("Staffing")}</SelectItem>
      <SelectItem id="TRANSPORTATION_AND_LOGISTICS">
        {t("Transportation and Logistics")}
      </SelectItem>
    </SelectFormikField>
  );
}
